const handleSectionView = (section) => {
  let virtualPageURL
  let virtualPageTitle
  switch (section.name) {
    case 'stay_section': {
      virtualPageURL = `/boeking/je-verblijf${window.location.search}`
      virtualPageTitle = 'Boeking - Je verblijf'
      break
    }
    case 'addition_section': {
      virtualPageURL = `/boeking/bij-te-boeken-extras${window.location.search}`
      virtualPageTitle = 'Boeking - Bij te boeken extras'
      break
    }
    case 'personal_details_section': {
      virtualPageURL = `/boeking/persoonsgegevens${window.location.search}`
      virtualPageTitle = 'Boeking - Persoonsgegevens'
      break
    }
    default: {
      break
    }
  }
  if (virtualPageURL && virtualPageTitle) {
    window.dataLayer.push({
      event: 'VirtualPageView',
      virtualPageURL,
      virtualPageTitle
    })
  }
}

const handleReservationConfirmationView = () => {
  window.dataLayer.push({
    event: 'VirtualPageView',
    virtualPageURL: `/boeking/bevestiging${window.location.search}`,
    virtualPageTitle: 'Boeking - Bevestiging'
  })
}

const handleReservationPaymentView = () => {
  window.dataLayer.push({
    event: 'VirtualPageView',
    virtualPageURL: `/boeking/betaling${window.location.search}`,
    virtualPageTitle: 'Boeking - Betaling'
  })
}

export default {
  handleReservationConfirmationView,
  handleReservationPaymentView,
  handleSectionView
}
